import { InstanceConfig } from './instance-config.model';
import { PAGE_NAMES } from '../helpers/constants';

export const FFM_INSTANCE_CONFIG: InstanceConfig = {
  key: 'ffm',
  labels: {
    clientSingular: 'Client',
    clientPlural: 'Clients',
    dmsSingular: 'DMS',
    dmsPlural: 'DMS',
  },
  features: {
    hiddenPageNames: [],
    hiddenRoutePrefixes: [],
    useAltLayout: false,
  },
};

export const PRSPR_INSTANCE_CONFIG: InstanceConfig = {
  key: 'prspr',
  labels: {
    clientSingular: 'Client',
    clientPlural: 'Clients',
    dmsSingular: 'DMS',
    dmsPlural: 'DMS',
  },
  features: {
    hiddenPageNames: [],
    hiddenRoutePrefixes: [],
    useAltLayout: false,
  },
};

export const CPJP_INSTANCE_CONFIG: InstanceConfig = {
  key: 'cpjp',
  labels: {
    clientSingular: 'Location',
    clientPlural: 'Locations',
    dmsSingular: 'Agency',
    dmsPlural: 'Agencies',
  },
  features: {
    hiddenPageNames: [
      PAGE_NAMES.Tasks,
      PAGE_NAMES.Shop,
      PAGE_NAMES.Products,
      PAGE_NAMES.Coupons,
      PAGE_NAMES.Subscriptions,
      PAGE_NAMES.Orders,
      PAGE_NAMES.Forms,
      PAGE_NAMES.MyAccount,
      PAGE_NAMES.Automations,
      'Partners',
      'FAQ',
    ],
    hiddenRoutePrefixes: [
      '/tasks',
      '/shop',
      '/products',
      '/coupons',
      '/subscriptions',
      '/orders',
      '/forms',
      '/myaccount',
    ],
    useAltLayout: true,
  },
};
